import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { ExhInviteBllService } from "../exh-invite-bll.service";
import { LoaderService } from "../../../shared/components/loader/loader.service";
import { InviteDetailsModel } from "../exh-invite.model";
import { CommonModule } from "@angular/common";
import { LeftSideNavComponent } from "../../../shared/layout/app/left-menu/left-side-nav.component";
import { HeaderComponent } from "../../../shared/layout/app/header/header.component";
import { ProfileBllService } from "../../profile/profile-bll.service";
import { UserEventStatusRespModel } from "../../profile/profile.model";
import { UserService } from "../../../core/services/user.service";
import { HomeBllService } from "../../home/home-bll.service";
import { EventDetailsResponseModel } from "../../home/home.model";
import { APIErrorModel } from "../../../shared/models/base-response.model";

@Component({
  selector: "app-invite-list",
  // Importing CommonModule for structural directives like *ngIf and *ngFor
  imports: [CommonModule,  LeftSideNavComponent,
      HeaderComponent],
  templateUrl: "./invite-list.component.html",
  styleUrl: "./invite-list.component.scss",
})
export class InviteListComponent {
  /**
   * inviteList
   * Holds the list of pending invitations fetched from backend API.
   */
  inviteList: InviteDetailsModel[] = [];
  /**
  * The status of the user's event.
  */
  userEventStatus: UserEventStatusRespModel | null = null;
  /**
   * Error message related to user event status.
   */
  userEventStatusError: string = "";

  eventDetails: EventDetailsResponseModel | null = null;

  /**
   * Constructor
   * @param router Angular Router service for navigation.
   * @param bll Business Logic Layer service handling invitation API calls.
   * @param loader Loader service to show/hide the spinner during API operations.
   */
  constructor(
    private router: Router,
    private bll: ExhInviteBllService,
    private loader: LoaderService,
    private profileBll: ProfileBllService,
    private userService: UserService,
    private bllService: HomeBllService
  ) {}

  /**
   * Lifecycle hook - ngOnInit
   * Called once when the component initializes.
   * Initiates fetching of pending invitations.
   */
  ngOnInit() {
    this.fetchUserEventStatus();
    this.getPendingInvites();
    this.loadEventDetails();
  }

  /**
   * Fetches pending invitations from backend via BLL.
   * Displays loader during API call and updates inviteList on success.
   */
  getPendingInvites() {
    this.loader.show();

    this.bll
      .getPendingInviteList()
      .then((response) => {
        // Validate response data structure
        this.inviteList = Array.isArray(response?.data) ? response.data : [];
        console.log("Pending Invites:", this.inviteList);
      })
      .catch((error: APIErrorModel) => {
        if (error.status === 410){
          this.router.navigate(['/home']);
        }
        console.error("Error fetching pending invites:", error);
      })
      .finally(() => {
        this.loader.hide();
      });
  }

  /**
   * trackById
   * Optimization function for *ngFor to improve rendering performance.
   * @param _ index (ignored)
   * @param inv current invite item
   * @returns unique ID for the invite
   */
  trackById(_: number, inv: InviteDetailsModel) {
    return inv.id;
  }

  /**
   * navigateToInviteDetails
   * Encodes invitation code and navigates to details page.
   * @param encodedCode Numeric invitation code from API
   */
  navigateToInviteDetails(code: string) {
    this.router.navigate(["/exh-invite/details"], {
      queryParams: { code },
    });
  }

  /**
   * onImgError
   * Fallback handler for broken or missing user images.
   * @param event Image load error event
   */
  onImgError(event: any) {
    event.target.src = "assets/images/default-profile-individual.png";
  }

   /**
   * Fetches the user event status and updates the user service with the profile information.
   */
   fetchUserEventStatus(): void {
 
    this.profileBll
      .submitGetUserEventStatus()
      .then((res) => {
        if (res !== null) {
          this.userEventStatus = res.data;
          this.userService.initializeFromEventStatus(this.userEventStatus);
        }
      })
      .catch((err: any) => {
        console.error("Error fetching user event status:", err);
      });
  }

  loadEventDetails() {
    this.bllService.fetchEventDetails()
      .then((response) => {
        this.eventDetails = response.data;     
        this.userService.setLeftMenu({
          allow_to_register: this.eventDetails.allow_to_register,
          show_digital_catalog: this.eventDetails.show_digital_catalog,
          event_status: this.eventDetails.event_status
        });       
      })
      .catch((error) => {
        console.error('Error fetching event details:', error);
      });
  }

}
